import * as i18next from "i18next";

export enum PeriodEnum {
  DAYS = "days",
  WEEKS = "weeks",
  MONTHS = "months",
}

export const translateKey = (value: PeriodEnum): string => {
  return "periodEnum." + value;
};

export const translatedValues = (t: i18next.TFunction) => {
  return allPeriodValues().map((value) => t(translateKey(value)));
};

export const allPeriodValues = () => {
  return [PeriodEnum.DAYS, PeriodEnum.WEEKS, PeriodEnum.MONTHS];
};
